// extracted by mini-css-extract-plugin
export default {"soundpad":"soundpad__0z1Jj","illustration":"illustration__kBaCD"};